<ng-container *ngIf="canView">

    <mat-expansion-panel *ngIf="!isValidating" [expanded]="true" style="margin: 10px 0px;">

        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon style="margin-top: -3px; margin-right: 5px;">monetization_on</mat-icon>Resumen de Caja
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
                <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true"
                    [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                    [allowResizing]='true' (rowDataBound)='rowDataBound($event)' *ngIf="!isSearching">
                    <e-columns>
                        <e-column field='ComunidadNombre' headerText='Nombre' textAlign="center" width="35%">
                            <ng-template #headerTemplate let-data>
                                {{getTraduccion('Comunidad')}}
                            </ng-template>
                        </e-column>
                        <e-column field='Balance' headerText='Importe' textAlign="right" format="N2" width="35%">
                            <ng-template #template let-data>
                                {{data.MonedaNombre}} {{data.Balance | number:'1.2-2'}}
                            </ng-template>
                        </e-column>
                        <e-column headerText='Acción' textAlign="center" width="25%">
                            <ng-template #template let-data>
                                <!-- Search icon -->
                                <a style="cursor: pointer; margin-right: 8px" (click)="openDialogDetalleMovimientos(data)" title="Ver Movimientos">
                                    <i class="fa fa-search fa-1x"></i>
                                </a>
                                <!-- Eye icon -->
                                <a style="cursor: pointer; margin-right: 5px" (click)="irMovimientoView()" title="Agregar movimiento">
                                    <i class="fa fa-plus fa-1x"></i>
                                </a>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>

    </mat-expansion-panel>
    
</ng-container>